<template>
  <div>
    <div>
      <new-ol-map-base
        ref="mapBase"
        :layers="waterSupplyLayers"
        @onMapReady="onMapReady($event)"
        @changeEnabledSublayer="changeEnabledSublayer($event)"
        @changeOpacitySublayer="changeOpacitySublayer($event)"
        @mapPointerMove="onPointerMove($event)"
      ></new-ol-map-base>
    </div>

    <tooltip-card-map v-show="map" :tooltipParams="tooltipParams">
    </tooltip-card-map>

    <v-card
      v-show="showReservoirOverlay"
      :class="`pa-2 primary darken-2 ${item.className}`"
      :id="`overlay-reservoir-${index}`"
      v-for="(item, index) in overlayerFeatures"
      :key="index"
      :style="`opacity: ${opacityReservoirOverlay}`"
    >
      <v-card-text>
        <v-row align="center">
          <v-progress-circular
            :value="item.properties.vol_perc"
            color="secondary lighten-1"
            :size="50"
            :width="6"
            :rotate="-90"
          ></v-progress-circular>
          <div class="ml-3 secondary--text text--lighten-1">
            <h1
              style="
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
              "
            >
              {{ item.properties.estnome }}
            </h1>
            <h2
              style="
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 18px;
              "
            >
              {{ (item.properties.vol_perc ? item.properties.vol_perc.toFixed(2) : "--") }}%
            </h2>
            <h1
              class="grey--text text--lighten-2"
              style="
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
              "
            >
              Última informação: {{ (item.properties.vol_perc ? formatDate(item.properties.data) : "--") }}
            </h1>
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import 'ol/ol.css';
import {TileWMS} from 'ol/source';
import {
  configZoom,
  getTooltipPropertiesOfLayer,
  getTooltipPropertiesFromFeature,
  getSubLayerByProperty,
} from '@/ol-maps/functions';
import {getSublayers, getDataFeatures, addOverlayMap} from '@/ol-maps/factory';
import moment from 'moment';
import NewOlMapBase from '@/components/common/NewOlMapBase.vue';
import TooltipCardMap from '../common/TooltipCardMap.vue';

export default {
  name: 'WaterSupplyMap',
  props: [],
  components: {
    TooltipCardMap,
    NewOlMapBase,
  },
  data: () => ({
    initialCenter: {
      center: [-50.97197, -24.628277],
      zoom: 7,
    },
    view: undefined,
    map: undefined,
    overlaysGroup: [],
    overlayerFeatures: [],
    showReservoirOverlay: false,
    opacityReservoirOverlay: 0.85,
    tooltipParams: [],
    flag: undefined,
    overlayLayerTooltipCard: undefined,
  }),
  computed: {
    waterSupplyLayers() {
      return this.$store.getters.waterSupplyLayers;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.$store.dispatch('loadWaterSupplyLayers');
      this.overlaysGroup = await getSublayers(this.waterSupplyLayers);
      this.overlayerFeatures = this.generateOverlayFeatures(
        this.overlaysGroup[0].overlayerFeatures,
      );
      if (this.$refs.mapBase) {
        this.$refs.mapBase.initialize();
      }
      this.$emit('volumesData', this.overlayerFeatures);
    },
    onMapReady(value) {
      const {map, view} = value;
      this.map = map;
      this.view = view;
      this.addOverlayerFeatures();
      this.addTooltipOverlay();
      this.showReservoirOverlay = true;
      this.zoomSaic();
      // this.$refs.mapBase.checkMapModal();
    },

    async onPointerMove(e) {
      const me = this;
      this.flag = e.pixel;
      await new Promise((r) => setTimeout(r, 400));
      if (this.flag != e.pixel) {
        return;
      }
      this.flag = undefined;

      let pixel = me.map.getEventPixel(e.originalEvent);
      me.clearTooltipParams();

      // eslint-disable-next-line no-unused-vars
      me.map.forEachLayerAtPixel(pixel, function (layer, r) {
        const source = layer.getSource();
        const propertiesLayer = layer.getProperties();
        if (
          source instanceof TileWMS &&
          propertiesLayer.tooltip_params &&
          !propertiesLayer.hide_on_menu
        ) {
          const view = me.map.getView();
          const fetchData = async () => {
            const features = await getDataFeatures(e, source, view);
            if (features && features.length > 0) {
              const {keys, icon_params} =
                getTooltipPropertiesOfLayer(propertiesLayer);

              features.forEach((feature_properties) => {
                me.addTooltipParams({
                  ...getTooltipPropertiesFromFeature(
                    keys,
                    feature_properties.properties,
                  ),
                  name: propertiesLayer.name,
                  zindex: propertiesLayer.property_params.zindex,
                  updatedAt:
                    feature_properties.properties.date ??
                    feature_properties.properties.date,
                  icon_params: propertiesLayer.icon_params
                    ? propertiesLayer.icon_params
                    : icon_params,
                });
              });
              me.overlayLayerTooltipCard.setPosition(e.coordinate);
            }
          };
          fetchData();
        }
      });

      if (this.tooltipParams.length === 0) {
        me.overlayLayerTooltipCard.setPosition(undefined);
      }
    },
    zoomSaic() {
      let zoom = 11;
      let center = [-49.212797, -25.470359];
      configZoom(this.view, zoom, center);
    },
    generateOverlayFeatures(overlayerFeatures) {
      let features = [];
      for (const key in overlayerFeatures) {
        let feature = overlayerFeatures[key];
        if (key == 1) {
          feature.positionOverlay = 'center-right';
          feature.className = 'overlay-reservoir-right';
        } else if (key == 2) {
          feature.positionOverlay = 'center-left';
          feature.className = 'overlay-reservoir-left';
        } else {
          feature.positionOverlay = 'bottom-center';
          feature.className = 'overlay-reservoir-center';
        }

        features.push(feature);
      }

      return features;
    },
    addOverlayerFeatures() {
      for (const key in this.overlayerFeatures) {
        let feature = this.overlayerFeatures[key];

        const overlay = document.getElementById(`overlay-reservoir-${key}`);

        const overlayAdded = addOverlayMap(
          this.map,
          overlay,
          feature.positionOverlay,
        );
        overlayAdded.setPosition(feature.geometry.coordinates);
      }
    },
    addTooltipOverlay() {
      const tooltipCard = document.getElementById('tooltip-card');
      this.overlayLayerTooltipCard = addOverlayMap(
        this.map,
        tooltipCard,
        'bottom-center',
      );
    },
    changeEnabledSublayer(value) {
      if (value.layerId === 682) {
        this.showReservoirOverlay = value.visible;

        const sublayer = getSubLayerByProperty(this.map, 'id', 694);
        sublayer.setVisible(value.visible);
      }
    },
    changeOpacitySublayer(value) {
      if (value.layerId === 682) {
        this.opacityReservoirOverlay = Math.min(value.opacity, 0.85);
      }
    },
    addTooltipParams(params) {
      this.tooltipParams.push(params);
    },
    clearTooltipParams() {
      this.tooltipParams = [];
    },
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped>
.tooltip {
  width: 300px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  opacity: 0.8;
  position: absolute;
  transition: 0.5s all ease;
  transition-delay: 0.5s;
  z-index: 1000;
}

div /deep/ .overlay-reservoir-center:before {
  position: absolute;
  content: '';
  height: 15px;
  width: 15px;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  background: var(--v-primary-darken2);
}

div /deep/ .overlay-reservoir-left:before {
  position: absolute;
  content: '';
  height: 15px;
  width: 15px;
  bottom: -8px;
  left: 0;
  top: 45%;
  transform: translateX(-50%) rotate(45deg);
  background: var(--v-primary-darken2);
}

div /deep/ .overlay-reservoir-right:before {
  position: absolute;
  content: '';
  height: 15px;
  width: 15px;
  bottom: -8px;
  right: 0;
  top: 45%;
  transform: translateX(50%) rotate(45deg);
  background: var(--v-primary-darken2);
}
.tooltip-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
}
.tooltip-subtitle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
}
</style>
